import { Notification } from 'rsuite';

import WarningIcon from '@material-ui/icons/Warning';
import InfoIcon from '@material-ui/icons/Info';
import CancelIcon from '@material-ui/icons/Cancel';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import styles from './notification.module.scss';

export const useNotification = () => {
  const messageBackground = {
    warn: styles.warn,
    info: styles.info,
    error: styles.error,
    success: styles.success,
  };

  const messageIcon = {
    warn: <WarningIcon className={styles['warning-icon']} />,
    info: <InfoIcon className={styles['info-icon']} />,
    error: <CancelIcon className={styles['error-icon']} />,
    success: <CheckCircleIcon className={styles['success-icon']} />,
  };

  const handleNotification = (type: keyof typeof messageBackground, message: string, duration?: number) => {
    Notification.open({
      key: 'notification-message',
      className: messageBackground[type],
      duration: duration || 5000,
      description: (
        <>
          {messageIcon[type]}
          <p>{message}</p>
        </>
      ),
    });
  };

  return {
    handleNotification,
  };
};
